import { useState, useCallback } from "react";

const useGAEvent = (eventDetails) => {
  const [trackedEvents, setTrackedEvents] = useState([]);

  const sendSingleEvent = useCallback((detail) => {
    if (!trackedEvents.includes(detail.value)) {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push(detail);
      // console.log("added >>> ", detail);
      setTrackedEvents([...trackedEvents, detail.value]);
    }
  }, [trackedEvents]);

  const sendEvent = useCallback((detail) => {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(detail);
    // console.log("added >>> ", detail);
  }, []);

  return { sendSingleEvent, sendEvent };
};

export default useGAEvent;
